<div class="gpd-scroll gpd-full-page spark-board">
  <div class="gpd-container-header">
    <div class="filter-container">
      <dx-text-box
        mode="search"
        [(value)]="searchTerm"
        (onValueChanged)="onSearchValueChanged($event)"
        placeholder="Search sparks"
        i18n-placeholder="@@searchSparks"
        valueChangeEvent="keyup"
        style="border-radius: 8px; border-color: var(--color-grey-300);"
      ></dx-text-box>

      <app-spark-filter
        [(filterState)]="filterState"
        [sparkTags]="sparkTags"
        [users]="users"
        (filterChanged)="onFilterChanged($event)"
      ></app-spark-filter>
    </div>

    <div class="actions-container">
      <span *ngIf="newSparks > 0" class="new-sparks"
        >{{ newSparks }} <span i18n="@@newSparks"> new sparks </span></span
      >
      <app-svg-icon
        icon="tick-double"
        [color]="
          newSparks > 0 ? 'var(--color-primary)' : 'var(--color-grey-500)'
        "
        [size]="36"
        [strokeWidth]="1"
        class="readall-icon"
        (click)="onSparkReadAllClick()"
        title="Mark all as read"
        i18n-title="@@markAllAsRead"
      ></app-svg-icon>
      <app-gpd-button
        text="Add Spark"
        i18n-text="@@addSpark"
        [disabled]="editingCard"
        icon="add"
        (click)="onSparkAddClick()"
      />
    </div>
  </div>

  <div class="edit-container" *ngIf="editingCard && !loadingBoard">
    <app-spark-editor-tiptap
      [spark]="editingCard"
      [sparkTags]="sparkTags"
      (onSparkSaved)="onSparkSaved()"
      (onSparkCancelled)="onSparkCancelled()">
    </app-spark-editor-tiptap>
  </div>
  <div
    class="pinned-spark-grid"
    #sparkGrid
    [style.gap.px]="SPARK_CARD_GAP"
    [style.--min-col-width]="SPARK_CARD_WIDTH + 'px'"
    *ngIf="pinnedSparks.length > 0 && !loadingBoard"
  >
    @for (spark of pinnedSparks; track $index) {
    <app-pinned-spark-card
      *ngIf="editingCard?.id != spark.id"
      #sparkCard
      [attr.id]="'spark-' + spark.id"
      [spark]="spark"
      [selected]="selectedCard === spark"
      [tags]="sparkTagMap"
      [currentBoardId]="boardId"
      (onSelect)="onSparkClick($index)"
      (edit)="onSparkEdit($event)"
      (delete)="onSparkDelete($event)"
      (pin)="onSparkPin($event)"
      (unpin)="onSparkUnpin($event)"
      (move)="onSparkMove($event)"
    ></app-pinned-spark-card>
    <div class="expanded-spark" *ngIf="$index === expandedCardIndex - 1">
      <app-spark-card
        #expandedCardOverlay
        [spark]="selectedCard"
        [tags]="sparkTagMap"
        [currentBoardId]="boardId"
        [expanded]="true"
        (edit)="onSparkEdit($event)"
        (delete)="onSparkDelete($event)"
        (pin)="onSparkPin($event)"
        (unpin)="onSparkUnpin($event)"
        (read)="onSparkRead($event)"
        (like)="onSparkLiked($event)"
        (move)="onSparkMove($event)"
      ></app-spark-card>
    </div>

    }
  </div>
  <h2
    class="spark-list-title"
    *ngIf="pinnedSparks.length > 0 && !loadingBoard"
    i18n="@@allSparks"
  >
    All Sparks
  </h2>
  <div class="spark-list" *ngIf="displayedSparks.length > 0 && !loadingBoard">
    @for (spark of displayedSparks; track $index) {
    <app-spark-card
      *ngIf="editingCard?.id != spark.id"
      [attr.id]="'spark-' + spark.id"
      [spark]="spark"
      [tags]="sparkTagMap"
      [currentBoardId]="boardId"
      (edit)="onSparkEdit($event)"
      (delete)="onSparkDelete($event)"
      (pin)="onSparkPin($event)"
      (unpin)="onSparkUnpin($event)"
      (read)="onSparkRead($event)"
      (like)="onSparkLiked($event)"
      (move)="onSparkMove($event)"
    ></app-spark-card>
    }
  </div>

  <!-- Empty state message -->
  <div class="empty-state" *ngIf="shouldShowEmptyState && !loadingBoard">
    <div class="empty-state-content">
      <h3 class="empty-state-title">
        <span *ngIf="hasActiveFilters" i18n="@@noMatchingSparks"
          >No matching sparks</span
        >
        <span *ngIf="!hasActiveFilters" i18n="@@noSparksYet"
          >No sparks yet</span
        >
      </h3>
      <p class="empty-state-message">{{ emptyStateMessage }}</p>
    </div>
  </div>
  <div class="load-more-container" *ngIf="hasMoreSparks && !loadingBoard">
    <app-gpd-button
      type="text"
      text="Load More Sparks"
      i18n-text="@@loadMoreSparks"
      icon="chevron-down"
      [disabled]="loadingSparks"
      (onClick)="loadMoreSparks()"
    >
    </app-gpd-button>
  </div>
</div>
